var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSkeletonTable)?_c('v-sheet',{staticClass:"pa-1",attrs:{"color":`grey ${_vm.theme.isDark ? 'darken-2' : 'lighten-3'}`}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"","max-height":"","type":"table-tbody"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }